import { FETCH_HL7_RECEIVED_MESSAGES_START, FETCH_HL7_RECEIVED_MESSAGES_SUCCESS, FETCH_HL7_RECEIVED_MESSAGES_ERROR } from '../../actions/admin/hl7ReceivedMessagesActions';

const INIT_STATE = {
    error: "",
    loading: false,
    message: '',
    pagination: {
        currentPage: 1,
        pageSize: 20,
        totalPages: 0,
        totalItems: 0,
    },
    hl7ReceivedMessages: []
};

const hl7ReceivedMessagesReducer = (state = INIT_STATE, action) => {
    let newState;
    let newUsers;
    let index;
    switch (action.type) {
        case FETCH_HL7_RECEIVED_MESSAGES_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_HL7_RECEIVED_MESSAGES_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, ...action.data };
        }
        case FETCH_HL7_RECEIVED_MESSAGES_ERROR: {
            return { ...state, loading: false, error: action.error, message: '' };
        }
        default:
            return state;
    }
}

export default hl7ReceivedMessagesReducer;
